export class ZedError extends Error {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args);
    this.name = 'ZedError';
  }
}

export class ZedLoadError extends ZedError {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args);
    this.name = 'ZedLoadError';
  }
}
